module.exports = __webpack_public_path__ + "static/img/headerA.f6777d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/headerA.png
// module id = vTMG
// module chunks = 16